module.exports = __webpack_public_path__ + "static/media/CitiIQLarge.60ab3d85.svg";